import axios from 'axios';
import { claimUpdatedThunk } from '../../claim';
import { openDialogAction } from '../../confirmation-dialog';
import { env } from '../../env';
import { hideLoadingAction, showLoadingAction } from '../../forms/loading-screen/actions';
import { ReduxThunkAction } from '../../redux/redux-actions';

type UpdateNotificationsReturn = Promise<any>;
export type UpdateNotifications = () => UpdateNotificationsReturn;
type UpdateNotificationsAction = () => ReduxThunkAction<UpdateNotificationsReturn>;
export const updateNotificationsAction: UpdateNotificationsAction = () => {
    return async (dispatch, getState) => {
        dispatch(showLoadingAction());
        const claim = getState().claimSession.claim;
        const notificationUri = `${env().CLAIMS_API}/api/Claim/${
            claim.claimId
        }/UpdateNotifications`;
        await axios
            .get(notificationUri)
            .then(response => {
                if (response.data) {
                    dispatch(claimUpdatedThunk(response.data));
                }
            })
            .catch(error => {
                let errorMessage = '';
                if (error.response) {
                    errorMessage = `Error Code ${error.response.status}`;
                } else {
                    errorMessage = error.message;
                }
                showErrorMessage(errorMessage);
            })
            .then(() => dispatch(hideLoadingAction()));

        function showErrorMessage(error: any) {
            const errorMessage = `An error (${error}) occured while refreshing astute information, please retry later`;
            dispatch(
                openDialogAction({
                    content: {
                        title: 'Error refreshing astute information',
                        body: errorMessage,
                        error: true,
                    },
                })
            );
        }
    };
};
